import axios from "axios";
import { baseAPI } from "../Utilities/constants";

export class ReadingService {
    static readonly readingEndPoint = `${baseAPI}/reading/bulk/excel`;
    static readonly deleteReadingEndPoint = `${baseAPI}/reading/bulk/excel/delete`;

    static readingColumns = ["meterNo", "units"];

    private static normalizeReadingRow(reading: Record<string, any>) {
        const normalized: Record<string, any> = {};

        Object.entries(reading || {}).forEach(([key, value]) => {
            const normalizedKey = key.trim().toLowerCase();
            const mappedKey =
                normalizedKey === "meter no" || normalizedKey === "meterno"
                    ? "meterNo"
                    : normalizedKey === "units"
                      ? "units"
                      : normalizedKey;

            normalized[mappedKey] = value;
        });

        return normalized;
    }

    static async createReadingCollections(
        readings: any[],
        payload?: Record<string, any>
    ) {
        const cleanCollection = [];

        for (const reading of readings) {
            const clean: any = {};
            const normalizedReading = this.normalizeReadingRow(reading);

            for (const col of this.readingColumns) {
                clean[col] = normalizedReading[col];
            }

            cleanCollection.push(clean);
        }

        try {
            const response = await axios.post(
                this.readingEndPoint,
                { meters: cleanCollection, ...(payload || {}) },
                {
                    withCredentials: true,
                }
            );
            return [response.data, null];
        } catch (err: any) {
            console.log("Error creating reading collections", err);
            return [null, err.response?.data];
        }
    }

    static async deleteReadingsByExcel(
        readings: any[],
        payload?: Record<string, any>
    ) {
        const cleanCollection = [];

        for (const reading of readings) {
            const normalizedReading = this.normalizeReadingRow(reading);
            cleanCollection.push({ meterNo: normalizedReading.meterNo });
        }

        try {
            const response = await axios.post(
                this.deleteReadingEndPoint,
                { meters: cleanCollection, ...(payload || {}) },
                {
                    withCredentials: true,
                }
            );
            return [response.data, null];
        } catch (err: any) {
            console.log("Error deleting reading collections", err);
            return [null, err.response?.data];
        }
    }
}
